<template>
    <div class="pcPage">
        <transition :name="transitionName">
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'pcpage',
    data: function () {
        return {
            transitionName:''
        }
    },
    watch: {
      // 使用watch 监听$router的变化
      $route (to, from) {
        if (to.meta.index > from.meta.index){
          // 设置动画名称
         this.transitionName = 'slide-left';
        } else{
          this.transitionName = 'slide-right';
       }

    }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.pcPage {
    width: 100%;
    height: 100%;
    min-width: 1200px;
    position: relative;
    
}
    .slide-top-enter-active,
    .slide-bottom-enter-active,
   .slide-right-enter-active,
   .slide-right-leave-active,
   .slide-left-enter-active,
   .slide-left-leave-active {
     will-change: transform;
     transition: all 500ms;
     position: absolute;
   }.slide-right-enter {
     opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }.slide-right-leave-active {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }.slide-left-enter {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }.slide-left-leave-active {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
</style>
